import script from "./ConciergeHeaderQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConciergeHeaderQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./ConciergeHeaderQuestion.vue?vue&type=style&index=0&id=223d3494&scoped=true&lang=css"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223d3494"]])

export default __exports__